import { isEqual, omitBy } from "lodash"
import { OrderInputs } from "../Trading/types/form"

// Check if an order is empty.
export const assertOrderEquals = (order: OrderInputs, otherOrder: OrderInputs) => {
  const cleanedOrder = omitBy(order, v => v === null || v === undefined || Number.isNaN(v))
  return isEqual(cleanedOrder, otherOrder)
}

// Check if all orders of a wave are empty.
export const isWaveEmpty = (orders: OrderInputs[], defaultOrder: OrderInputs) =>
  !orders.map(order => assertOrderEquals(order, defaultOrder)).includes(false)
